// Because of the way this file is set up, this works the same
// as a document.ready statement.
// Add your code, either within the misc: section, or create your own function
// if you create your own, make sure to add a line at the bottom to run that code
// ie: Engine.ui.misc();

$(function () {
  
  $("img.img-responsive").lazyload();
  
  "use strict";
  var Engine = {
    ui: {
      misc: function () {
        $("button.navbar-toggler, button.navbar-toggler_close").on('click', function () {
          $('body').toggleClass("open");
          return false;
        });

        $('.cart-close').click(function(e){
          var container = $(".cart-side-panel");
          var menu_contain = $(".inner_outer");
          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) 
          {
            $('body').removeClass("CartOpen ");
          }
          if (!menu_contain.is(e.target) && menu_contain.has(e.target).length === 0) 
          {
            $('body').removeClass("open ");
          }
        });

        $(".menu_toggle_down").click(function () {
          $(this).parents('.site-nav--has-dropdown').find('.site-nav__dropdown').slideToggle('slow');
          $(this).toggleClass('active');
          return false;
        });
        $(".filter_catalog_list li .collapsible-trigger").on('click', function () {
          $(this).parents('.filter_items').find('ul.filter_group').slideToggle('slow');
          $(this).toggleClass('active');
          return false;
        });

        $('.plus').on('click', function() {
          var $qty = $(this).parents('.product-form__item').find("ul.QuantityBox li .QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (!isNaN(currentVal)) {
            var max = jQuery('#Quantity').data('max');
            var p_title = jQuery(this).data('title');
            var value = parseInt(jQuery('#Quantity').val(), 10) || 0;
            if (value == max) {
              alert('We only have ' + max + ' of ' + p_title + ' item in stock');
              return false;
              jQuery(this).val(max);
            }
            $('.minus').removeClass('disabled');
            $qty.val(currentVal + 1);
          }
        });
        $('.minus').on('click', function() {
          var $qty = $(this).parents('.product-form__item').find("ul.QuantityBox li .QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (!isNaN(currentVal) && currentVal > 0) {
            var min = jQuery('#Quantity').data('min');
            var value = parseInt(jQuery('#Quantity').val(), 10) || 0;

            if(value == 2){
              value = 1;
            }
            console.log(min);
            console.log(value);
            if (value == min) {
              $('.minus').addClass('disabled');
            }
            $qty.val(currentVal - 1);
          }
        });


        $(document).on('click', '.wc_product_review_badge', function() {           
          $('a[href="#review"]').trigger( "click" );
          $('html, body').animate({
            scrollTop: $("#tabs_view").offset().top - 50
          }, 1500);
        });
        $(document).on('click', '.message-block', function() {
          $('.overlay').css({"opacity":"1", "visibility":"visible"});
        });
        $('#shipping_popup a').click(function(){
          $('.overlay').css({"opacity":"0", "visibility":"hidden"});
        });
      },
    },


    utils: {
      sliders: function() {
        $('.image_slider').slick({
          centerMode: false,
          slidesToShow: 1,
          slide: "li",
          dots: false
        });
        $('.shop_thumb').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          infinite: false,
        });
        $('.shop_slider').slick({
          slidesToShow: 4,
          asNavFor: '.shop_thumb',
          dots: false,
          arrows: false,
          infinite: false,
          slide:"li",
          focusOnSelect: true,
          responsive: [{
            breakpoint: 992,
            settings: {
              slidesToShow: 3
            }
          },
                       {
                         breakpoint: 768,
                         settings: {
                           slidesToShow: 3
                         }
                       },
                       {
                         breakpoint: 576,
                         settings: {
                           slidesToShow: 2
                         }
                       }]
        }); 
        $('button.slick-next.slick-arrow').addClass("btn-disabled");

        $('.shop_thumb').on('beforeChange', function(event, slick, currentSlide){
          $('button.slick-next.slick-arrow').addClass("btn-disabled");
        });
        $('input[type="radio"]').on('click',function(){
          $('button.slick-next.slick-arrow').removeClass("btn-disabled");
        });
      },
    },
  };
  Engine.ui.misc();
  Engine.utils.sliders();
});
$('textarea').each(function () {
  $(this).val($(this).val().trim());
});
function responsivecolumn(){
  if($(window).width() <= 575 ){
    $('.tab-pane h4').click(function(e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.next().hasClass('active')) {
        $this.next().removeClass('active');
        $this.next().slideUp(350);
      } else {
        $this.parent().parent().find('.desc_div_contain').removeClass('active');
        $this.parent().parent().find('.desc_div_contain').slideUp(350);
        $this.next().toggleClass('active');
        $this.next().slideDown(350);
      }
      if($this.hasClass('active_font')){
        $this.removeClass('active_font');
      }
      else{
        $this.parent().parent().find('h4').removeClass('active_font');
        $this.addClass('active_font');
      }
    });
    var len = 35;
    var p = document.getElementsByClassName('product_inner_name');
    var i;
    for (i = 0; i < p.length; i++) {
      if (p) {
        var trunc = p[i].innerHTML;
        if (trunc.length > len) {
          trunc = trunc.substring(0, len);
          trunc = trunc.replace(/\w+$/, '');
          trunc += '<a href="#" ' +
            'onclick="this.parentNode.innerHTML=' +
            'unescape(\'' + escape(p[i].innerHTML) + '\');return false;">' +
            '...<\/a>';
          p[i].innerHTML = trunc;
        }
      }
    }
  }
  else if($(window).width() >= 576 ){
    $(".desc_div_contain").show();

  }
  var maxHeight = Math.max.apply(null, $(".product_name h3").map(function () {
    return $(this).height();
  }).get());
  $(".product_name h3").height(maxHeight);
  var mainHead = $('header').innerHeight();


  if($(window).width() <= 767 ){
    var heightPara = Math.max.apply(null, $(".banner_desc_tag .desc_area").map(function () {
      return $(this).height();
    }).get());
    $(".banner_desc_tag .desc_area").height(heightPara);
  }
}

$(document).ready(function () {
  var blognameHeight = Math.max.apply(null, $(".article_grid_title").map(function () {
    return $(this).height();
  }).get());
  $(".article_grid_title").height(blognameHeight);

  responsivecolumn();
  $(function () {
    $(".search_icon").on("click", function () {
      if($('.search_widget').hasClass("active")){
        if($('#search_desk').val() == ''){
          alert('Please enter search text');
        }else{
          $('.search_widget form').submit();
        }
      }else{
        $('.search_widget').addClass('active');
        $('.menu_bar.desktop_nav').css({ "opacity": "0", "visibility": "hidden", "display": "none" }) ;             
      }
    });
  });
  $(function () {
    var ignore = Array(".search_widget");
    ignore.forEach(function (item) {
      $(item).click(function () {
        return false;
      });
    });
    $(document).on("click", function () {
      $(".search_widget").removeClass('active');
      $('.menu_bar.desktop_nav').css({ "opacity": "1", "visibility": "visible", "display": "block"  }) ;
    });
  });
  $('.close_search_icon').on("click", function () {
    $(".search_widget").removeClass('active');
  });
  setTimeout(function(){ 
    var heightAnnounce = $('.qh-smart-bar__block').innerHeight();
  }, 5000);
  $(window).scroll(function(){
    var sticky = $('header'),
        scroll = $(window).scrollTop();
    var heightAnnounce = $('.qh-smart-bar__block').innerHeight();
    $('header').css('top',heightAnnounce +'px');
    if (scroll > 0){
      sticky.addClass('fixed');
    }
    else {
      sticky.removeClass('fixed');
      $('header').css('top',0);
    }
  });
  
  $("#shoppingcart").click(function(){
    var ajax_cart_val = {
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      global: true,
      success: function(item){
        $.event.trigger('ajaxSuccess');
      },
      error: function(XMLHttpRequest, textStatus){
        console.log(XMLHttpRequest);
      }
    };
    jQuery.ajax(ajax_cart_val);
  }); 
  
});

$(document).resize(function () {
  responsivecolumn();
});



var $filterSidebar = $('.product-sidebar');
var $toggleButton = $('#open-filters');
var $overlay = $('body').find('.widgets-filter-overlay');
function _open() {
  $filterSidebar.addClass('open');
  if (! $overlay.length) {
    $('body').append('<div class="widgets-filter-overlay"></div>');
  }

  $('body').addClass('filter_open');
}

function _close() {
  $filterSidebar.removeClass('open');
  $(document).find('.widgets-filter-overlay').remove();
  $('body').removeClass('filter_open');
}

$toggleButton.on('click', function() {
  if (! $filterSidebar.hasClass('open')) {
    _open();
  } else {
    _close();
  }
});

$("button.navbar-toggler").on('click', function() {
  $('.filters-toolbar__input-wrapper .dropdown').removeClass('open')
});

$(".filter_group li a").on('click', function() {
  $('body').removeClass('filter_open');
  $('.product-sidebar').removeClass('open');
  $(document).find('.widgets-filter-overlay').remove();
});

$('body').on('click', '.widgets-filter-overlay', function() {
  _close();
});

$('.btn_close_filter').click(function(){
  _close();
});
/*
$(window).load(function(){
  $(".mcs-horizontal").mCustomScrollbar({
    axis:"x",
    theme:"dark-thick",
    autoExpandScrollbar:true,    
    updateOnContentResize:true,
    scrollbarPosition: 'outside',
    advanced:{ updateOnSelectorChange: false },
    advanced:{autoExpandHorizontalScroll:true},
    scrollInertia: 200,
    snapAmount:0,
    mouseWheel:{scrollAmount:0},
    advanced:{ updateOnImageLoad: false }
  });
});
*/